export default __webpack_public_path__ + "static/media/placeholder-2.03a18399.jpg";